import React, { Component } from 'react';
import InputText, { TextArea } from '../../../../commonModules/interface/form-input-inline';
import { Box, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';

class CallClient extends Component {
    state = {  }
    handleChange = (e) => {
        this.props.handleChange(e)
    }
    render() {
        return (
            <Box>
                <FormControl component="fieldset">
                    <FormLabel component="legend">Réponse Client ?</FormLabel>
                    <RadioGroup 
                        aria-label="answer" 
                        name="answer" 
                        value={this.props.answer} 
                        onChange={this.handleChange }
                        style={{ flexDirection: "row"}}
                        error={this.props.errors.answer}
                    >
                        <FormControlLabel value="oui" control={<Radio />} label="Oui" />
                        <FormControlLabel value="non" control={<Radio />} label="Non" />
                    </RadioGroup>
                </FormControl>
                
                
                <TextArea
                    id="comment" 
                    onChange={this.handleChange} 
                    value={this.props.comment} 
                    name="comment" 
                    rows={5}
                    label={this.props.answer === "oui" ? "Résumé de la Conversation" : "Commentaire"}
                    error={this.props.errors.comment}
                />
                {this.props.answer === "oui" &&
            
                <InputText 
                    id="callLength" 
                    onChange={this.handleChange} 
                    value={this.props.callLength}
                    name="callLength"
                    label="Durée de la Conversation (en Secondes)"
                    error={this.props.errors.callLength}
                />
                
                }
                {this.props.userInfo.activeAlert &&
                    <FormControl component="fieldset">
                    <FormLabel component="legend">Alerte en Cours, Desactiver ?</FormLabel>
                    <RadioGroup 
                        aria-label="alertDone" 
                        name="alertDone" 
                        value={this.props.alertDone} 
                        onChange={this.handleChange}
                        style={{ flexDirection: "row"}}
                        error={this.props.errors.alertDone}
                    >
                        <FormControlLabel value="oui" control={<Radio />} label="Oui, probème résolu" />
                        <FormControlLabel value="non" control={<Radio />} label="Non, pas encore résolu" />
                    </RadioGroup>
                </FormControl>
                }
            </Box>
        );
    }
}

export default CallClient;